export default "__VITE_ASSET__CZjWrm_A__"